import { TypePolicy } from '@apollo/client';
import {
  RecruitmentSearchResponse,
  AttendanceHistoriesResponse,
  WorkerBankTransferResponse,
  ReviewsFromFacilityResponse,
  StatementOfEarningsResponse,
  FavoriteRecruitmentListResponse,
  GetPenaltyPointHistoriesResponse,
  GetIncentivePointHistoriesResponse,
} from '../generated';

export const fieldPolicies: TypePolicy['fields'] = {
  favoriteRecruitmentList: {
    keyArgs: false,
    merge: (
      existing: FavoriteRecruitmentListResponse = {
        __typename: 'FavoriteRecruitmentListResponse',
        recruitments: [],
        paging: { nextCursor: null, __typename: 'RecruitmentSearchPaging' },
      },
      incoming: FavoriteRecruitmentListResponse,
    ) => {
      const result: FavoriteRecruitmentListResponse = {
        ...incoming,
        recruitments: [...existing.recruitments, ...incoming.recruitments],
        paging: incoming.paging,
      };

      return result;
    },
  },
  statementOfEarnings: {
    keyArgs: false,
    merge: (
      existing: StatementOfEarningsResponse = {
        __typename: 'StatementOfEarningsResponse',
        statementOfEarnings: [],
        paging: null,
      },
      incoming: StatementOfEarningsResponse,
    ) => {
      const result: StatementOfEarningsResponse = {
        ...incoming,
        statementOfEarnings: [...existing.statementOfEarnings, ...incoming.statementOfEarnings],
        paging: incoming.paging,
      };

      return result;
    },
  },
  reviewsFromFacility: {
    keyArgs: false,
    merge: (
      existing: ReviewsFromFacilityResponse = {
        __typename: 'ReviewsFromFacilityResponse',
        reviews: [],
        paging: { cursor: null, __typename: 'ReviewsFromFacilityPaging' },
      },
      incoming: ReviewsFromFacilityResponse,
    ) => {
      const result: ReviewsFromFacilityResponse = {
        ...incoming,
        reviews: [...existing.reviews, ...incoming.reviews],
        paging: incoming.paging,
      };

      return result;
    },
  },
  workerBankTransfer: {
    keyArgs: false,
    merge: (
      existing: WorkerBankTransferResponse = {
        __typename: 'WorkerBankTransferResponse',
        transfers: [],
        paging: { nextCursor: null, __typename: 'WorkerBankTransferPaging' },
      },
      incoming: WorkerBankTransferResponse,
    ) => {
      const result: WorkerBankTransferResponse = {
        ...incoming,
        transfers: [...existing.transfers, ...incoming.transfers],
        paging: incoming.paging,
      };

      return result;
    },
  },
  attendanceHistories: {
    keyArgs: false,
    merge: (
      existing: AttendanceHistoriesResponse = {
        __typename: 'AttendanceHistoriesResponse',
        attendances: [],
        paging: { nextCursor: null, __typename: 'Paging' },
      },
      incoming: AttendanceHistoriesResponse,
    ) => {
      const result: AttendanceHistoriesResponse = {
        ...incoming,
        attendances: [...existing.attendances, ...incoming.attendances],
        paging: incoming.paging,
      };

      return result;
    },
  },
  recruitmentSearch: {
    keyArgs: false,
    merge: (
      existing: RecruitmentSearchResponse = {
        __typename: 'RecruitmentSearchResponse',
        recruitments: [],
        paging: { nextCursor: null, __typename: 'RecruitmentSearchPaging' },
      },
      incoming: RecruitmentSearchResponse,
    ) => {
      const result: RecruitmentSearchResponse = {
        ...incoming,
        recruitments: [...existing.recruitments, ...incoming.recruitments],
        paging: incoming.paging,
      };

      return result;
    },
  },
  getPenaltyPointHistories: {
    keyArgs: false,
    merge(
      existing: GetPenaltyPointHistoriesResponse = {
        __typename: 'GetPenaltyPointHistoriesResponse',
        histories: [],
        cursor: null,
      },
      incoming: GetPenaltyPointHistoriesResponse,
    ): GetPenaltyPointHistoriesResponse {
      return {
        ...incoming,
        histories: [...existing.histories, ...incoming.histories],
        cursor: incoming.cursor,
      };
    },
  },
  getIncentivePointHistories: {
    keyArgs: false,
    merge(
      existing: GetIncentivePointHistoriesResponse = {
        __typename: 'GetIncentivePointHistoriesResponse',
        histories: [],
        cursor: null,
      },
      incoming: GetIncentivePointHistoriesResponse,
    ): GetIncentivePointHistoriesResponse {
      return {
        ...incoming,
        histories: [...existing.histories, ...incoming.histories],
        cursor: incoming.cursor,
      };
    },
  },
};
